import styled from 'styled-components';

export default styled.span`
  color: ${props => props.light ? "#fff" : props.dark ? "#333333" : "gray"};
  text-decoration: none;
  transition: 250ms ease;
  margin-left: ${props => props.first ? "0" : "1rem"};
  font-size: 1em; /* Tamaño de letra más grande */
  font-weight: bold; /* Texto en negrita */
  &:visited{
    color: ${props => props.light ? "#fff" : props.dark ? "#333333" : "blue"};
  }
  &:hover{
    color: ${props => props.light ? "#fff" : props.theme.primaryColor};
    text-decoration: ${props => props.light && "underline"};
  }  
  @media(min-width: 992px){
    margin-left: ${props => props.first ? "0" : "3rem"};
    color: ${props => props.light ? "rgba(255, 255, 255, .7)" : props.dark ? "#333333" : "#00163b"};
    font-size: .8rem; /* Ajusta el tamaño del texto según tus preferencias */
    &:hover{
      color: ${props => props.light ? "#fff" : props.theme.primaryColor};
      text-decoration: ${props => props.light && "none"};
    }
  }
  
`;
